import * as React from 'react';
import { Flex, IconButton } from '@radix-ui/themes';

export function LayoutButton({ flag, state, onClick, children, label }) {

  return (
    state === flag ? (
      <IconButton onClick={() => onClick(flag)} className="sidebar-icon" size="3" variant="solid" aria-label={label} aria-current="page">
        {children}
      </IconButton>
    ) : (
      <Flex className="sidebar-icon-container" width="40px" height="40px" align="center" justify="center"
        direction="column" gap="1">
        <IconButton onClick={() => onClick(flag)} className="sidebar-icon" size="3" variant="soft" color="gray" aria-label={label}>
          {React.isValidElement(children) ? 
            React.cloneElement(children, { color: "gray", ...children.props}) : 
            children
          }
        </IconButton>
      </Flex>
    )
  );
}
